/**
 * View to select a date and time
 * Consists of one jQuery datepicker (pickaday) and two fields for hour and minutes
 **/

import BaseView from '../../base-view';

export default BaseView.extend({
	events: {
		'blur .js-hour': 'onTimeInputBlur',
		'blur .js-minute': 'onTimeInputBlur'
	},

	dateFull: null, // becomes a date object

	initialize: function() {
		// reference field
		this.inputDateFull = this.query('.js-date-time-full');

		this.inputDate = this.query('.js-date');
		this.inputHour = this.query('.js-hour');
		this.inputMinute = this.query('.js-minute');

		this.dateFull = new Date(this.inputDateFull.value);

		// create date component
		this.$pickerDate = this.initDatePicker();
		this.$pickerDate.on('set', this.onDateChange.bind(this));
	},

	/**
	 * Create and return the datepicker
	 **/
	initDatePicker: function() {
		var dateEl = $('.js-date', this.$el)[0]; // Scoped jQuery forces us to wrap a DOM element.

		return $(dateEl).pickadate({
			format: 'dd.mm.yyyy',
			max: true
		}).pickadate('picker');
	},

	/**
	 * Date change handler
	 * called when a date is selected in the datepicker
	 **/
	onDateChange: function(e) {
		if (e.select) {
			this.dateFull = new Date(e.select);
			this.setTime();
		}
	},

	/**
	 * Updates the time when an input field is blurred
	 **/
	onTimeInputBlur: function(e) {
		var val = e.currentTarget.value;

		if (val.length === 1) {
			val = '0' + val;
			e.currentTarget.value = val;
		}

		this.setTime();
	},

	/**
	 * Sets the date/time
	 **/
	setTime: function() {
		var year = this.dateFull.getFullYear(),
			month = this.dateFull.getMonth() + 1,
			day = this.dateFull.getDate(),
			hours = this.inputHour.value,
			minutes = this.inputMinute.value;

		// fill hidden input with formatted date/time
		this.inputDateFull.value = year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;
	},

	/**
	 * Clear input fields
	 **/
	clear: function() {
		this.inputDate.setAttribute('value', '');
		this.inputHour.setAttribute('value', '');
		this.inputMinute.setAttribute('value', '');
		this.inputDateFull.setAttribute('value', '');
	}
});

